module.exports = __webpack_public_path__ + "static/img/8.22c177c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/8.jpg
// module id = 9x52
// module chunks = 29